import { Outlet } from "react-router-dom";
import { Suspense } from "react";
import MikeLoading from "../loading/Loading";

const PublicRoute = () => {
  return (
    <Suspense fallback={<MikeLoading />}>
      <Outlet />
    </Suspense>
  );
};

export default PublicRoute;
